module.exports = "<div class=\"text-center\">\r\n  <h2>404 - Page not found</h2>\r\n</div>\r\n\r\n"